import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stateIcon'
})
export class StateIconPipe implements PipeTransform {

  transform(value: string): any {
    switch (value) {
      case 'INPROGRESS':
        return 'access_time';
      case 'CREATED':
        return 'star';
      case 'ACK':
      case 'PENDING':
      case 'PARTIAL':
        return 'help';
      case 'CANCELLING':
        return 'fast_rewind';
      case 'CANCELLED':
        return 'skip_previous';
      case 'HELD':
        return 'warning';
      case 'COMPLETED':
        return 'done';
      case 'SAVED':
        return 'bookmark';
      case 'CANCELLING_HELD':
        return 'warning';
      case 'FAILED':
        return 'close';
      case 'UNKNOWN':
      default:
        return '';
    }


  }

}
